
import React, { Component } from 'react';

import Link from '../../../../components/ZUILib/Link';
import CheckBox from '../../../../components/ZUILib/CheckBox';
import TextInput from '../../../../components/ZUILib/TextInput';
import InputButton from '../../../../components/ZUILib/InputButton';
import commonUtil from '../../../../utils/commonUtil';
import serverClientUtil from '../../../../utils/serverClientUtil';

import errorLables from '../../../../utils/errors/LP_GR_error.json';

class SignInWap extends Component {
  constructor() {
    super();
    this.clickHandlerForgotPassword = this.clickHandlerForgotPassword.bind(this);
    this.warningMessage = null;
  }
  showRemeberMe = false
  loginForm = {
    login: '',
    password: '',
    autoLoginCheckbox: '',
  }

  showError = () => {
    const error = this.props && this.props.errorData && this.props.errorData.result;
    if (error.status.status === 'success') {
      this.warning.setMessage('');
    } else if (error.status.status === 'failure') {
      this.warning.setMessage(error.status.errorMessage);
    }
  }

  validate = () => {
    const emailValidationRules = [
      { functionRef: commonUtil.isValueAvailable, funcData: [this.login.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.login.email.required') },
      { functionRef: commonUtil.validateEmail, funcData: [this.login.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.login.email.invalid') },
    ];

    const passwordValidationRiles = [
      { functionRef: commonUtil.isValueAvailable, funcData: [this.password.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.login.password.required') },
      { functionRef: commonUtil.validatePassword, funcData: [this.password.getValue(), 8], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.login.password.invalid') },
    ];

    const isLoginValid = commonUtil.validateTextInput(emailValidationRules, this.login, null);
    const isPasswordValid = commonUtil.validateTextInput(passwordValidationRiles, this.password, null);

    if (isLoginValid && isPasswordValid) {
      this.loginForm.login = this.login.getValue();
      this.loginForm.password = this.password.getValue();
      this.loginForm.autoLoginCheckbox = this.userAutoLogingChk.isChecked() ? 'true' : 'false';
    }

    const { login, password } = this.loginForm;
    if (login && password) {
      return true;
    }
    return false;
  }

  clickHandlerForgotPassword() {
    this.setState({ t: 't' });
    const _url = serverClientUtil.getLPFullURL() + '/users/forgotPassword?login=';
    window.open(_url);
  }
  toggleRemeberMeMessage = () => {
    this.showRemeberMe = !this.showRemeberMe;
    const autologinTooltip = document.querySelector('.homeSessionContainer');
    if (this.showRemeberMe) {
      autologinTooltip.style.display = 'block';
    } else {
      autologinTooltip.style.display = 'none';
    }
  }
  handleLoginOnEnter = (e) => {
    if (e.key === 'Enter' && this.validate()) {
      this.handleUserLogin();
    }
  }
  handleUserLogin = () => {
    if (this.validate()) {
      const { _handleUserLogin } = this.props; // eslint-disable-line no-shadow
      _handleUserLogin(this.loginForm);
    }
  }
  render() {
    const { lables } = this.props;
    const SignInButton = {
      type: 'button',
      value: commonUtil.getLabel(lables.createLogin, 'login.button.label'),
      autoFocus: false,
      style: 'btnPrimary size-Full',
      onClickHandler: this.handleUserLogin,
    };

    // json for button Create Account
    const switchAccountButton = {
      type: 'button',
      value: commonUtil.getLabel(lables.createLogin, 'create.account.lable'),
      id: 'createAccountMobile',
      autoFocus: false,
      cssClass: 'btnPrimaryAction size-Full',
      onClickHandler: this.props.showMobileCreateAccountSection,
    };
    const rememberMeCheckBoxConfig = {
      displayName: commonUtil.getLabel(lables.createLogin, 'login.keep.me.login'),
      id: 'signinchk',
      name: '',
      value: '',
      disabled: '',
    };
    return (
      <div id="sectionSesion">
        <h1 style={{ marginBottom: '30px' }} className="titleSection">Iniciar sesión</h1>
        <form id="startSesion">
          <div className="formBlock">
            <TextInput
              className="inputMaterial"
              labelClassName="placeHolderMaterial"
              htmlId="username"
              label={commonUtil.getLabel(lables.createLogin, 'login.user.name')}
              name="User"
              maxlength="100"
              required="true"
              ref={login => this.login = login}
              onKeyPress={this.handleLoginOnEnter}
            />
          </div>
          <div className="formBlock">
            <TextInput
              className="inputMaterial"
              labelClassName="placeHolderMaterial"
              htmlId="password"
              label={commonUtil.getLabel(lables.createLogin, 'login.user.password')}
              name="password"
              type="password"
              required="true"
              ref={password => this.password = password}
              onKeyPress={this.handleLoginOnEnter}
            />
          </div>
          <a className="forgotPassword" onClick={this.clickHandlerForgotPassword} >{commonUtil.getLabel(lables.createLogin, 'forgot.password.link')}</a>
          <InputButton buttonAttr={SignInButton} />
        </form>
        <div className="row">
          <div className="col-xs-12 p-l-35">
            <CheckBox displayName={rememberMeCheckBoxConfig.displayName} id={rememberMeCheckBoxConfig.id} ref={(e) => { this.userAutoLogingChk = e; }}>
              <a className="p-l-15" onClick={this.toggleRemeberMeMessage}>{commonUtil.getLabel(lables.createLogin, 'login.detalla.link')}<i className="icon-caret_down" /></a>
              <div className="homeSessionContainer" ref={e => this.autoSignUpWAP = e} style={{ display: 'none' }}>
                <div className="rememberMeContent">
                  <p>{commonUtil.getLabel(lables.createLogin, 'createLogin.rememberme.header.content')} <i className="icon-tache closeContainer" onClick={this.toggleRemeberMeMessage} /></p>
                  <hr />
                  <p>{commonUtil.getLabel(lables.createLogin, 'createLogin.rememberme.content1')}</p>
                  <p>{commonUtil.getLabel(lables.createLogin, 'createLogin.rememberme.content2')}</p>
                </div>
              </div>
            </CheckBox>
          </div>
        </div>
        <Link linkJSON={switchAccountButton}>{commonUtil.getLabel(lables.createLogin, 'create.account.lable')}</Link>
      </div>
    );
  }
}
export default SignInWap;
